import { useCallback, useMemo } from 'react'
import { useApp } from '@/lib/provider/AppProvider'
import {
  ICON_SIZE,
  ServiceItemInterface,
  ServicesItems,
} from '@/lib/definitions/services'
import { ProductIcon } from '@/lib/misc/ProductIcons'
import { getProductKnowledgeBaseUrl } from '../definitions/types'
import { FLAGS } from './useFeatureFlag'

const GATED_FEATURES = [
  FLAGS.IP_TRANSIT_OVER_GRE,
  FLAGS.DDOS_PROTECTION,
  FLAGS.CLOUD_CONNECT,
]

export const useProducts = (): ServiceItemInterface[] => {
  const [appState] = useApp()

  const isEnabled = useCallback(
    (name: string) => {
      if (typeof appState.waffleFlags === 'undefined') return false
      const flags = appState.waffleFlags || []
      if (GATED_FEATURES.includes(name)) return flags.includes(name)
      return true
    },
    [appState.waffleFlags]
  )

  return useMemo(() => {
    const items = ServicesItems.filter((s) => isEnabled(s.id))
    const dynamic =
      appState.appInfo?.products &&
      appState.waffleFlags.includes('dynamic_products')
        ? appState.appInfo.products.map((p: any) => ({
            ...p,
            id: p.product_key,
            cta: `/services/${p.product_key.replace(/_/g, '-')}`,
            icon: (
              <ProductIcon
                productId={p.icon || p.product_key}
                size={ICON_SIZE}
              />
            ),
            knowledgeBaseUrl: getProductKnowledgeBaseUrl(p.product_key),
          }))
        : []
    return [...items, ...dynamic]
  }, [isEnabled, appState.appInfo?.products, appState.waffleFlags])
}
